/**
 * File view.js
 */
(function ($) {
    "use strict";

    $(document).ready(function () {
        $('.q-and-a .accordion').each(function (index) {
            let $accordion = $(this);
            let currentId = $accordion.attr('id');

            // Check for duplicate ID
            if ($('[id="' + currentId + '"]').length > 1) {
                // Create a unique ID using index or timestamp
                const newId = currentId + '-' + Date.now() + '-' + index;
                $accordion.attr('id', newId);

                // Update child collapses with new data-bs-parent
                $accordion.find('.accordion-collapse').attr('data-bs-parent', `#${newId}`);
            } else {
                // Update child collapses with existing ID
                $accordion.find('.accordion-collapse').attr('data-bs-parent', `#${currentId}`);
            }
        });
    });
})(jQuery);

jQuery(document).ready(function($) {
  $('.accordion[itemtype="https://schema.org/FAQPage"]').each(function() {

    $(this).find('[itemtype="https://schema.org/Question"]').each(function() {
      const $question = $(this);

      // Add itemprop="name" to the question title if missing
      const $title = $question.find('.q-and-a__box-title');
      if ($title.length && !$title.attr('itemprop')) {
        $title.attr('itemprop', 'name');
      }

      // Find the Answer block
      const $answer = $question.find('[itemtype="https://schema.org/Answer"]');
      if ($answer.length) {
        const $body = $question.closest('.accordion-item').find('.accordion-body');

        // Check if itemprop="text" already exists
        const hasTextWrapper = $body.find('[itemprop="text"]').length > 0;

        if (!hasTextWrapper) {
          // Create the wrapper div
          const $textWrapper = $('<div>', { itemprop: 'text' });

          // Move all children into the wrapper
          $body.children().each(function() {
            $(this).appendTo($textWrapper);
          });

          // Append the wrapper back into the body
          $body.append($textWrapper);
        }
      }
    });

  });
});

jQuery(document).ready(function($) {
  const usedIds = new Set();
  let counter = 1;

  $('.q-and-a .accordion-item').each(function() {
    const $item = $(this);
    let currentId = $item.attr('id');

    // If ID is missing or already used, generate a new one
    if (!currentId || usedIds.has(currentId)) {
      currentId = 'accordion-item-' + counter;
      $item.attr('id', currentId);
    }

    usedIds.add(currentId);

    counter++;
  });
  
  // Force all accordion items open
  $('.q-and-a--always-open .accordion-collapse').each(function() {
    $(this).addClass('show').css('height', 'auto');
  });

  // Disable toggle behavior and remove collapsed state
  $('.q-and-a--always-open .accordion-button').each(function() {
    $(this).removeClass('collapsed')
           .attr('aria-expanded', 'true')
           .off('click') // Remove toggle
           .css({
             'pointer-events': 'none',
             'cursor': 'default',
             'background-color': '#e9f5ff'
           });
  });
});
